import { render, staticRenderFns } from "./TechnicalReport.vue?vue&type=template&id=6b3cb968"
import script from "./TechnicalReport.vue?vue&type=script&lang=js"
export * from "./TechnicalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports